import { Alert, Divider, Grid, List, Stack } from "@mui/material";
import MenuItem from "components/MenuItem";
import ActionLoader from "components/UI/ActionLoader";
import MuiOutlineButton from "components/UI/MuiOutlineButton";
import { fetchServices } from "framework/services";
import { Feature } from "models/api";
import { useQuery } from "react-query";
import LogoutIcon from "@mui/icons-material/Logout";
import useApp from "hooks/useApp";
import { useTranslation } from "react-i18next";
import React, { useCallback, useEffect, useState } from "react";


interface Props {
  setOpenDrawer: React.Dispatch<React.SetStateAction<boolean>>;
}

export const viewable = (role: string, roles: string[]) => {
  return roles?.includes(role);
};

const DrawerMenu: React.FC<Props> = ({ setOpenDrawer }) => {



  const [selectedFeature, setSelectedFeature] = React.useState<Feature | null>(
    null
  );

  const { data, isError, isLoading } = useQuery<Feature[]>(
    "features",
    fetchServices
  );
  let user = JSON.parse(localStorage.getItem("profile") || "{}");

  let features: Feature[] | undefined = user.IsAdmin
    ? data
    : data?.filter((feature) => !feature.IsAdmin && !feature?.hidden);
  const { push } = useApp();
  const { t } = useTranslation();
  const handleLogout = () => {
    localStorage.clear();
    push("/login");
    return;
  };


  if (isError)
    return (
      <Alert severity="error">An error occurred while fetching features.</Alert>
    );
  if (isLoading) return <ActionLoader position="fixed" />;

  const handleSelectUnLinkFeature = (feature: Feature) =>
    setSelectedFeature(feature);



  return (
    <List>
      <Divider sx={{ mb: 1 }} />
      <Stack spacing={2}>
        {features &&
          features.length > 0 &&
          features.map((feature, index) => {

            return (
              <MenuItem
                feature={feature}
                key={index}
                name={t(feature.name)}
                icon={feature.icon}
                color={"black"}
                slug={feature.slug}
                setOpenDrawer={setOpenDrawer}
                open={true}
                onSelectUnLinkFeature={handleSelectUnLinkFeature}
                hasChildren={feature.children.length > 0 ? true : false}
              />
            )
          })}
        <Grid container justifyContent={"center"}>
          <MuiOutlineButton
            variant="outlined"
            color="inherit"
            size="small"
            startIcon={<LogoutIcon sx={{ fill: "#232323" }} />}
            onClick={handleLogout}
          >
            Logout
          </MuiOutlineButton>
        </Grid>
      </Stack>
    </List>
  );
};

export default DrawerMenu;
